module.exports = __webpack_public_path__ + "static/media/h3.a82c008f.png";